import React from "react"
import {Chip} from "@mui/material"

import {useCustomerID} from "../useCustomerID"

import {useOfferStatus} from "@indebted/api/customerOffersAPI"
import {colors} from "@indebted/theme/colors"

const chipStyle = {
	color: "white",
	fontSize: "0.75rem",
	fontWeight: 500,
	letterSpacing: "0.14px",
	height: "20px",
	borderRadius: "100px",
	marginLeft: "8px",
}

export function OffersAvailableBadge() {
	const customerID = useCustomerID()
	const status = useOfferStatus(customerID)

	if (status === "available") {
		return (
			<Chip
				label="Offer(s) available"
				size="small"
				style={{...chipStyle, backgroundColor: colors.success["600"]}}
			/>
		)
	}

	if (status === "upcoming") {
		return (
			<Chip
				label="Offer(s) coming soon"
				size="small"
				style={{...chipStyle, backgroundColor: colors.warning["500"]}}
			/>
		)
	}

	return null
}
